import axios from "axios";

const request = (url, method, data, success, error) => {
    var bodyFormData = new FormData();

    for (var key in data) {
        if (data.hasOwnProperty(key)) {
            bodyFormData.set(key, data[key]);
        }
    }

    let baseUrl = window.location.hostname  === 'localhost' ? 'http://localhost/aeb-insurance-api/public/' : '/api/public/';
    let headers =  {
        'Content-Type': 'multipart/form-data',
    };

    let axios_body = {
        method: method,
        url: baseUrl+url,
        data: bodyFormData,
        config: {
            headers: headers
        }
    };

    axios(axios_body).then(success).catch(error);

};

export default request;